export const STORE_URL = "https://editoraquitanda.com.br/";
export const WHATSAPP_URL = "https://wa.me/[NUMERO-WHATSAPP]";
export const CONTACT_EMAIL = "geral@triacompany.com";
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const EASE = [0.22, 1, 0.36, 1];
